/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SettingsMenuItemType = {
    Chat: 'chat',
    Calendar: 'calendar',
    Contacts: 'contacts',
    Communities: 'communities',
    Feedback: 'feedback',
    Knowledgebase: 'knowledgebase',
    News: 'news',
    Meetings: 'meetings',
    Profile: 'profile',
    Settings: 'settings',
    Tv: 'tv',
    Workflow: 'workflow'
} as const;
export type SettingsMenuItemType = typeof SettingsMenuItemType[keyof typeof SettingsMenuItemType];

